import mergeRoleCapabilityPatch from '@/lib/settings/rolePermissions/mergeRoleCapabilityPatch.js';

const mergeRoleCapabilityPayload = ({ currentPayload, patchPayload, fallbackRoleId } = {}) => {
  const basePayload = currentPayload && typeof currentPayload === 'object' ? currentPayload : null;
  const nextPayload = patchPayload && typeof patchPayload === 'object' ? patchPayload : null;

  return {
    ...(basePayload || {}),
    ...(nextPayload || {}),
    role: nextPayload?.role || basePayload?.role || (fallbackRoleId ? { id: fallbackRoleId } : null),
    capabilities: mergeRoleCapabilityPatch({
      currentValue: basePayload?.capabilities || {},
      patchValue: nextPayload?.capabilities || {}
    })
  };
};

export default mergeRoleCapabilityPayload;
